var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongJilu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5A.5.5 0 013 2h10a.5.5 0 01.5.5v11a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5v-11z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5h6M5 8h3.5",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNSAyLjVDMi41IDIuMjIzODYgMi43MjM4NiAyIDMgMkgxM0MxMy4yNzYxIDIgMTMuNSAyLjIyMzg2IDEzLjUgMi41VjEzLjVDMTMuNSAxMy43NzYxIDEzLjI3NjEgMTQgMTMgMTRIOEgzQzIuNzIzODYgMTQgMi41IDEzLjc3NjEgMi41IDEzLjVWMi41WiIgc3Ryb2tlPSIjM0Y0NjVDIi8+CjxwYXRoIGQ9Ik01IDVIMTFNNSA4SDguNSIgc3Ryb2tlPSIjM0Y0NjVDIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgTongyongJilu as ReactComponent };